module.exports = __webpack_public_path__ + "static/media/13.233f520a.jpg";